import { render } from "./RequestSummary.view.vue?vue&type=template&id=140b27aa"
import script from "./RequestSummary.view.vue?vue&type=script&lang=js"
export * from "./RequestSummary.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__